@if (erro(); as mensagem) {
    <div class="kanban-estado" role="alert">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <p class="kanban-estado-titulo">{{ mensagem }}</p>
        <button pButton type="button" label="Tentar novamente" class="p-button-text" (click)="recarregar()"></button>
    </div>
} @else if (carregando()) {
    <div class="kanban-estado">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        <p class="kanban-estado-titulo">Carregando o quadro…</p>
    </div>
} @else if (quadroVazio()) {
    <!--
        O estado vazio é do QUADRO, e não de quem lhe passa a listagem: só aqui se sabe que, além dos
        protocolos vivos recebidos por `itens`, existem os CONCLUÍDOS buscados por fora. Decidido lá
        fora, o quadro sumia inteiro — com a coluna Concluído dentro dele — sempre que a listagem viva
        esvaziava, que é justamente o que um encerramento em lote bem-sucedido provoca.
    -->
    <div class="kanban-estado">
        <i class="pi pi-search" aria-hidden="true"></i>
        <p class="kanban-estado-titulo">Nenhum protocolo encontrado</p>
        <p class="kanban-estado-subtitulo">Ajuste os filtros ou escolha outro serviço.</p>
    </div>
} @else {
    <div class="kanban-quadro" cdkDropListGroup>
        @for (coluna of colunas(); track coluna.status.id) {
            <section class="kanban-coluna" [class]="'kanban-coluna kanban-cor-' + indiceCor(coluna.status)">
                <header class="kanban-coluna-header">
                    <!--
                        Contador e nome formam um bloco só, à esquerda. Soltos, o `space-between` do
                        cabeçalho jogaria o do meio para o centro — com o filtro à direita, seriam três
                        itens espalhados em vez de "quem é a coluna" de um lado e a ação do outro.
                    -->
                    <span class="kanban-coluna-identidade">
                        <!--
                            Com filtro, o contador mostra os DOIS números: filtro ligado e esquecido, com
                            o contador mostrando só os visíveis, se lê como "sumiu trabalho do quadro".
                        -->
                        <span class="kanban-coluna-contador" [title]="colunaFiltrada(coluna.status) ? coluna.itens.length + ' de ' + coluna.total + ' com o filtro atual' : ''">
                            @if (colunaFiltrada(coluna.status)) {
                                {{ coluna.itens.length }}<span class="kanban-coluna-contador-total">/{{ coluna.total }}</span>
                            } @else {
                                {{ coluna.total }}
                            }
                        </span>
                        <span class="kanban-coluna-titulo">{{ coluna.status.nome }}</span>
                    </span>
                    <!--
                        Segundo bloco do `space-between`, ao lado do de identidade: um terceiro filho
                        solto aqui se espalharia entre os dois — por isso o botão de lote entra NESTE
                        grupo, ao lado do de filtro, em vez de virar um terceiro item do cabeçalho.
                    -->
                    <span class="kanban-coluna-acoes">
                        @if (podeEncerrarEmLote(coluna) && totalSelecionados() && colunaDaSelecao() === coluna.status.id) {
                            <!--
                                O verbo aparece escrito: só a contagem num botão verde não diz o que
                                o clique faz, e esta é a ação mais cara da coluna — ela finaliza N
                                protocolos de uma vez, no portal. O número fica ao lado, porque o
                                quanto também é decisão: finalizar 1 e finalizar 30 não se conferem
                                com a mesma atenção.

                                O `aria-label` COMEÇA pelo mesmo verbo que se lê na tela: quem usa
                                comando de voz fala o rótulo visível, e um nome acessível que
                                começasse por outra palavra não responderia a ele.
                            -->
                            <button
                                type="button"
                                class="kanban-coluna-lote"
                                [attr.aria-label]="'Finalizar ' + totalSelecionados() + ' protocolos selecionados da coluna ' + coluna.status.nome"
                                [title]="'Finalizar ' + totalSelecionados() + ' selecionados'"
                                (click)="solicitarEncerramentoEmLote(coluna)"
                            >
                                <i class="pi pi-check-square" aria-hidden="true"></i>
                                <span class="kanban-coluna-lote-rotulo">Finalizar</span>
                                <span class="kanban-coluna-lote-total">{{ totalSelecionados() }}</span>
                            </button>
                        }
                        <button
                            type="button"
                            class="kanban-coluna-filtro"
                            [class.kanban-coluna-filtro--ativo]="colunaFiltrada(coluna.status)"
                            [attr.aria-label]="(colunaFiltrada(coluna.status) ? 'Alterar filtro de ' : 'Filtrar ') + coluna.status.nome"
                            [title]="colunaFiltrada(coluna.status) ? 'Filtro aplicado' : 'Filtrar esta área'"
                            (click)="abrirFiltro(coluna.status)"
                        >
                            <i class="pi pi-filter" aria-hidden="true"></i>
                        </button>
                    </span>
                </header>

                <div class="kanban-coluna-corpo" cdkDropList [cdkDropListData]="coluna.status" [cdkDropListEnterPredicate]="podeEntrarNaColuna" (cdkDropListDropped)="onDrop($event)">
                    @for (item of coluna.itens; track item.portal) {
                        <!-- Uma chamada por ciclo, e não uma por leitura: o kebab e o [model] do menu leem a mesma lista. -->
                        @let acoesDoItem = acoesDoCard(item);

                        <article
                            class="kanban-card"
                            cdkDrag
                            [cdkDragData]="item"
                            [cdkDragDisabled]="!arrastavel(item)"
                            [class.kanban-card--travado]="!arrastavel(item)"
                            [class.kanban-card--urgente]="ehUrgente(item)"
                            [class.kanban-card--selecionado]="isSelecionado(item)"
                            [attr.aria-disabled]="!arrastavel(item) ? true : null"
                            [title]="arrastavel(item) ? '' : 'Protocolo sem número/ano: não pode ser movido no quadro.'"
                            (appAoAparecer)="carregarFotoDoMedico(item)"
                        >
                            <div class="kanban-card-topo">
                                <!--
                                    Fora do botão de abrir, pelo mesmo motivo da foto abaixo: conteúdo interativo
                                    dentro de <button> é marcação inválida. O CDK inicia o gesto de arraste tanto
                                    no `mousedown` quanto no `touchstart` do elemento raiz do `cdkDrag` — o card
                                    inteiro é a alça (não há `cdkDragHandle` no app) —, e sem conter os DOIS um
                                    toque (touchscreen) ou um micro-arrasto (mouse) ao marcar o checkbox levaria
                                    o card para outra coluna.
                                -->
                                <!--
                                    Só nas colunas de onde um lote pode NASCER. No backlog, e em
                                    qualquer coluna cuja conclusiva não seja destino aceito, o botão
                                    "Encerrar em lote" nunca aparece — e um checkbox que marca cards
                                    para uma ação que jamais será oferecida ali é marcação que não
                                    leva a lugar nenhum.
                                -->
                                @if (colunaPodeIniciarLote(coluna)) {
                                    <p-checkbox
                                        class="kanban-card-selecao"
                                        [binary]="true"
                                        [ngModel]="isSelecionado(item)"
                                        (ngModelChange)="toggleSelecionado(item, coluna)"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="!arrastavel(item)"
                                        [ariaLabel]="'Selecionar protocolo ' + identificadorProtocolo(item)"
                                        (click)="$event.stopPropagation()"
                                        (mousedown)="$event.stopPropagation()"
                                        (touchstart)="$event.stopPropagation()"
                                    ></p-checkbox>
                                }

                                <!--
                                    A foto fica FORA do botão de abrir: ela virou clicável por conta própria (o
                                    clique amplia o retrato) e conteúdo interativo dentro de <button> é marcação
                                    inválida — o navegador e o leitor de tela não têm como decidir quem responde
                                    ao clique. Abrir o protocolo continua a um clique de distância pelo nome ao
                                    lado e pelo botão "Visualizar" no pé do card.
                                -->
                                <span class="kanban-card-identificacao">
                                    <ng-container [ngTemplateOutlet]="avatarDoMedico" [ngTemplateOutletContext]="{ $implicit: item }" />

                                    <button type="button" class="kanban-card-abrir" (click)="onSelect(item)">
                                        <!-- Protocolo, nome e identificação são um bloco só, ao lado da foto: os três respondem "quem é este protocolo". -->
                                        <span class="kanban-card-nomes">
                                            <span class="kanban-badge">#{{ identificadorProtocolo(item) }}</span>
                                            <strong class="kanban-card-solicitante">{{ item.empresa }}</strong>
                                            @if (identificacaoDoSolicitante(item); as identificacao) {
                                                <span class="kanban-card-documento">{{ identificacao }}</span>
                                            }
                                        </span>
                                    </button>
                                </span>

                                <!-- Menu sem item nenhum não vira botão: kebab que abre vazio é pior que kebab nenhum. -->
                                @if (acoesDoItem.length) {
                                    <!-- appendTo="body": o corpo da coluna rola (overflow), e o popup ancorado ali dentro seria recortado. -->
                                    <p-menu #menuDoCard [id]="idDoMenuDoCard(item)" [model]="acoesDoItem" [popup]="true" appendTo="body" (onHide)="aoFecharMenuDoCard(item)" />
                                    <!--
                                        `aria-haspopup`/`aria-expanded`/`aria-controls`: sem eles o leitor de tela anuncia
                                        só "botão", e este kebab é agora a ÚNICA porta para Efetivar e Cancelar — antes
                                        botões visíveis na faixa do pé. WCAG 4.1.2.
                                    -->
                                    <button
                                        type="button"
                                        class="kanban-card-menu"
                                        aria-haspopup="menu"
                                        [attr.aria-controls]="idDoMenuDoCard(item)"
                                        [attr.aria-expanded]="menuAbertoDoCard() === item.portal"
                                        [attr.aria-label]="'Ações do protocolo ' + identificadorProtocolo(item)"
                                        (click)="alternarMenuDoCard(menuDoCard, item, $event)"
                                    >
                                        <i class="pi pi-ellipsis-v" aria-hidden="true"></i>
                                    </button>
                                }
                            </div>

                            <!--
                                A anuidade é o único campo do bloco que só existe quando está RUIM (o @if
                                é `=== false`): não é um dado do protocolo, é um alerta. Por isso sai como
                                badge, e não como o par rótulo/valor dos vizinhos — que são informação
                                neutra e aparecem sempre. Fica fora do <dl> porque badge solto entre
                                <dt>/<dd> não é marcação válida; a posição na tela é a mesma de antes.
                            -->
                            @if (item.isAnuidadePaga === false) {
                                <span class="kanban-tag kanban-tag--anuidade"> <i class="pi pi-wallet" aria-hidden="true"></i> Anuidade pendente </span>
                            }

                            <dl class="kanban-card-dados">
                                <!-- O CRM saiu daqui: virou a linha de identificação sob o nome, junto de quem ele identifica. -->
                                @if (exibirDiretorTecnico() && item.diretorTecnicoNome) {
                                    <div class="kanban-card-dado kanban-card-diretor">
                                        <dt><i class="pi pi-user" aria-hidden="true"></i> Diretor técnico</dt>
                                        <dd>{{ item.diretorTecnicoNome }}{{ item.diretorTecnicoCrmUf ? ' · ' + item.diretorTecnicoCrmUf : '' }}</dd>
                                    </div>
                                }
                                @if (ultimaTramitacaoResumo(item); as tramitacao) {
                                    <div class="kanban-card-dado kanban-card-tramitacao">
                                        <dt><i class="pi pi-clock" aria-hidden="true"></i> Última tramitação</dt>
                                        <dd [title]="tramitacao">{{ tramitacao }}</dd>
                                    </div>
                                }
                            </dl>

                            <div class="kanban-card-rodape">
                                <span class="kanban-tag kanban-tag--situacao" [class]="'kanban-tag kanban-tag--situacao situacao-' + situacaoClasse(item.situacaoCodigo)">
                                    {{ situacaoRotulo(item.situacaoCodigo) }}
                                </span>
                                <!--
                                    Ao lado da situacao, e nao misturada com pagamento/urgencia: das quatro perguntas da
                                    faixa, situacao e modalidade sao as que valem para TODO card (as outras duas so
                                    aparecem quando ha algo fora do comum). Mesma FORMA das vizinhas (retangulo em
                                    negrito, no SCSS); o que a separa e o icone proprio daqui e a cor roxa — ver
                                    kanban-protocolos.scss.
                                -->
                                @if (modalidadeInscricaoRotulo(item.modalidadeInscricao); as modalidade) {
                                    <span class="kanban-tag kanban-tag--modalidade">
                                        <i class="pi pi-id-card" aria-hidden="true"></i>
                                        {{ modalidade }}
                                    </span>
                                }
                                <!--
                                    Tres estados, nao dois: item.inPago e boolean | undefined. undefined significa que o
                                    protocolo nao informou pagamento — nao e a mesma coisa que estar pago, e por isso
                                    NENHUM badge desenha nesse caso. Inventar "Pago" a partir de campo nao informado seria
                                    mentir sobre dinheiro. So true e false desenham; o texto ("Pago"/"Não pago") continua
                                    no badge porque a cor sozinha nao pode carregar o estado.
                                -->
                                @if (item.inPago !== undefined) {
                                    <span class="kanban-tag kanban-tag--pagamento" [class.kanban-tag--pagamento-sim]="item.inPago" [class.kanban-tag--pagamento-nao]="!item.inPago">
                                        {{ item.inPago ? 'Pago' : 'Não pago' }}
                                    </span>
                                }
                                @if (ehUrgente(item)) {
                                    <span class="kanban-badge kanban-badge--urgente">{{ criticidadeUrgente()?.nome }}</span>
                                }
                            </div>

                            <!-- Efetivar e cancelar saíram daqui para o menu de três pontos; ficaram as duas ações de leitura, agora com rótulo. -->
                            <div class="kanban-card-acoes">
                                <button type="button" class="kanban-card-olho" [attr.aria-label]="'Ver informações do protocolo ' + identificadorProtocolo(item)" (click)="onSelect(item)">
                                    <i class="pi pi-eye" aria-hidden="true"></i> Visualizar
                                </button>

                                <!-- O rótulo acessível começa pelo texto visível ("comentários"): quem navega por comando de voz pede o que lê na tela. -->
                                <button type="button" class="kanban-card-anotacoes" [attr.aria-label]="'Comentários do protocolo ' + identificadorProtocolo(item)" (click)="abrirHistorico(item)">
                                    <i class="pi pi-comment" aria-hidden="true"></i> {{ rotuloAnotacoes(item) }}
                                </button>

                                @if (nomeResponsavel(item); as responsavel) {
                                    @if (fotoResponsavel(item); as foto) {
                                        <!-- Mesmo tratamento do retrato do solicitante: clique amplia, overlay no body, clique contido. -->
                                        <span class="kanban-card-avatar--responsavel-caixa" [title]="responsavel">
                                            <p-image
                                                [src]="foto"
                                                [alt]="'Encaminhado para ' + responsavel"
                                                [preview]="true"
                                                [appendTo]="'body'"
                                                styleClass="kanban-card-avatar--clicavel"
                                                imageClass="kanban-card-avatar"
                                                (click)="$event.stopPropagation()"
                                            />
                                        </span>
                                    } @else {
                                        <span class="kanban-card-avatar kanban-card-avatar--responsavel kanban-card-avatar--iniciais" [title]="responsavel" [attr.aria-label]="'Encaminhado para ' + responsavel">{{ iniciaisResponsavel(item) }}</span>
                                    }
                                }
                            </div>
                        </article>
                    } @empty {
                        <p class="kanban-coluna-vazia">Nenhum protocolo aqui.</p>
                    }
                </div>
            </section>
        }
    </div>
}

<!--
    `closable`/`closeOnEscape` presos a `salvando()`: o botao Cancelar ja fica desabilitado durante a
    chamada, mas o "X" e o ESC continuavam ativos — e fechar com a chamada ao portal em voo termina
    com a solicitacao finalizada la e o card parado aqui, sem ninguem saber.

    Largura: 32rem apertava o conteudo. A raiz do app usa 12px, entao eram ~384px para acomodar os
    dois badges lado a lado, o seletor de criticidade e a anotacao.
-->
<p-dialog
    appDialogoPadrao="pi pi-briefcase"
    descricao="Leve o protocolo para outra etapa do quadro."
    header="Mover solicitação"
    [visible]="movimentoPendente() !== null"
    (visibleChange)="$event ? null : cancelarMovimento()"
    [style]="{ width: '38rem' }"
    [closable]="!salvando()"
    [closeOnEscape]="!salvando()"
>
    @if (movimentoPendente(); as movimento) {
        <p class="kanban-dialogo-linha mb-3">
            <span class="kanban-badge-status" [class]="'kanban-badge-status kanban-cor-' + indiceCor(movimento.origem)">{{ movimento.origem.nome }}</span>
            <span class="kanban-dialogo-seta">&rarr;</span>
            <span class="kanban-badge-status kanban-badge-status--destino" [class]="'kanban-badge-status kanban-badge-status--destino kanban-cor-' + indiceCor(movimento.destino)">{{ movimento.destino.nome }}</span>
        </p>
        <!--
            Mesmo bloco de identificação do card e do diálogo de histórico: foto grande à esquerda e,
            ao lado dela, protocolo e nome empilhados. Estavam em duas linhas soltas — o badge sozinho
            numa e a foto miúda com o nome na de baixo.
            Sem rótulo "Protocolo": o badge é reconhecido pela forma, a mesma do card que o usuário
            acabou de arrastar.
        -->
        <div class="kanban-dialogo-identificacao mb-3">
            <ng-container [ngTemplateOutlet]="avatarDoMedico" [ngTemplateOutletContext]="{ $implicit: movimento.item }" />
            <span class="kanban-card-nomes">
                <span class="kanban-badge">{{ identificadorProtocolo(movimento.item) }}</span>
                <strong class="kanban-card-solicitante">{{ movimento.item.empresa }}</strong>
            </span>
        </div>
        @if (exigeEscolhaAoConcluir()) {
            <!--
                fieldset/legend porque os dois radios sao UMA pergunta: soltos, o leitor de tela
                anuncia "Efetivar" e "Cancelar" sem dizer de que sao resposta.
            -->
            <!--
                `acaoJaFinalizadaNoPortal()` congela a pergunta inteira: o portal ja EXECUTOU a acao, e
                isso nao se desfaz. Radio ainda editavel ali deixaria o analista marcar a outra opcao,
                digitar o motivo e confirmar — e o motivo seria descartado em silencio, o protocolo
                continuaria efetivado e o card iria para CONCLUIDO. O aviso logo abaixo diz qual foi a
                acao registrada e que so falta gravar o movimento.
            -->
            <!--
                O `input[type=radio]` continua aqui, só que fora da vista (ver SCSS): é ele que dá o
                grupo exclusivo, a navegação por setas e o anúncio do leitor de tela. O que virou badge
                é o RÓTULO. Trocar por dois botões perderia as três coisas.
                Ícone decorativo: o texto ao lado já diz a ação.
            -->
            <!--
                A escolha corrente entra como CLASSE no grupo, e não como `:checked` no CSS: o shim de
                encapsulamento reescreve o seletor irmão e a regra deixa de casar (o badge saía sempre
                neutro). Uma classe só, no pai, evita repetir a condição em cada badge.
            -->
            <fieldset [class]="'kanban-acoes-conclusao mb-4 kanban-acoes-conclusao--' + (acaoAoConcluir() ?? 'nenhuma')" [disabled]="acaoJaFinalizadaNoPortal() !== null">
                <legend class="kanban-dialogo-rotulo">Ao concluir *</legend>
                <label class="kanban-acao kanban-acao-efetivar">
                    <input type="radio" name="acaoAoConcluir" value="efetivar" [disabled]="!podeEfetivarAoConcluir() || acaoJaFinalizadaNoPortal() !== null" [checked]="acaoAoConcluir() === 'efetivar'" (change)="acaoAoConcluir.set('efetivar')" />
                    <!--
                        O rótulo nomeia o ato, e no pré-prestador inerte ele deixa de ser "Efetivar":
                        marcar aqui inscreve a empresa SEM pagamento. Quem decide é `rotuloDaEfetivacao`.
                    -->
                    <span [class]="acaoAoConcluir() === 'efetivar' ? 'kanban-acao-badge kanban-acao-badge--efetivar' : 'kanban-acao-badge'"><i class="pi pi-check-circle" aria-hidden="true"></i> {{ rotuloDaEfetivacao() }}</span>
                </label>
                <label class="kanban-acao kanban-acao-cancelar">
                    <input type="radio" name="acaoAoConcluir" value="cancelar" [disabled]="!podeCancelarAoConcluir() || acaoJaFinalizadaNoPortal() !== null" [checked]="acaoAoConcluir() === 'cancelar'" (change)="acaoAoConcluir.set('cancelar')" />
                    <span [class]="acaoAoConcluir() === 'cancelar' ? 'kanban-acao-badge kanban-acao-badge--cancelar' : 'kanban-acao-badge'"><i class="pi pi-times-circle" aria-hidden="true"></i> Cancelar</span>
                </label>
            </fieldset>
            @if (avisoDaConclusao(); as aviso) {
                <!-- Radio apagado (ou movimento barrado) sem explicacao vira chamado de suporte. -->
                <p class="kanban-dialogo-aviso mb-3" [class.kanban-dialogo-aviso--bloqueio]="nenhumaAcaoAoConcluir()" role="alert">{{ aviso }}</p>
            }

            @if (acaoAoConcluir() === 'cancelar') {
                <label class="block mb-2 text-sm font-medium" for="kanban-motivo-conclusao">Motivo do cancelamento *</label>
                <textarea id="kanban-motivo-conclusao" pTextarea class="w-full mb-3" rows="3" maxlength="500" [disabled]="acaoJaFinalizadaNoPortal() !== null" [ngModel]="motivoDaConclusao()" (ngModelChange)="motivoDaConclusao.set($event)"></textarea>
            }
            @if (acaoAoConcluir() === 'efetivar' && campoExigidoNaEfetivacao() !== 'nenhum') {
                <label class="block mb-2 text-sm font-medium" for="kanban-dado-efetivacao">{{ rotuloDoCampoExigido() }} *</label>
                @if (campoExigidoNaEfetivacao() === 'data') {
                    <input id="kanban-dado-efetivacao" type="date" class="w-full mb-3" [disabled]="acaoJaFinalizadaNoPortal() !== null" [ngModel]="dadoDaEfetivacao()" (ngModelChange)="dadoDaEfetivacao.set($event)" />
                } @else {
                    <!-- 4000, o mesmo da tela de detalhe: é o MESMO campo do mesmo serviço, e limites diferentes truncariam conforme a porta de entrada. -->
                    <textarea
                        id="kanban-dado-efetivacao"
                        pTextarea
                        class="w-full mb-3"
                        rows="3"
                        maxlength="4000"
                        [disabled]="acaoJaFinalizadaNoPortal() !== null"
                        [ngModel]="dadoDaEfetivacao()"
                        (ngModelChange)="dadoDaEfetivacao.set($event)"
                    ></textarea>
                }
            }
        }
        <label class="block mb-2 text-sm font-medium" for="kanban-criticidade">Criticidade</label>
        <p-select
            inputId="kanban-criticidade"
            styleClass="w-full mb-3"
            [options]="criticidades()"
            optionLabel="nome"
            optionValue="id"
            [ngModel]="criticidadeSelecionada()"
            (ngModelChange)="criticidadeSelecionada.set($event)"
            placeholder="Selecione a criticidade"
            appendTo="body"
        ></p-select>
        @if (responsavelObrigatorio()) {
            <label class="block mb-2 text-sm font-medium" for="kanban-responsavel">Encaminhar para</label>
            <p-select
                inputId="kanban-responsavel"
                styleClass="w-full mb-3"
                [options]="responsaveis()"
                optionLabel="nome"
                optionValue="idWebUsuario"
                [ngModel]="responsavelSelecionado()"
                (ngModelChange)="responsavelSelecionado.set($event)"
                placeholder="Selecione um responsável"
                [filter]="true"
                filterBy="nome"
                appendTo="body"
            >
                <ng-template pTemplate="selectedItem" let-escolhido>
                    @if (escolhido) {
                        <span class="kanban-opcao-responsavel">
                            @if (fotoResponsavelPorId(escolhido.idWebUsuario); as foto) {
                                <p-image [src]="foto" [alt]="escolhido.nome" [preview]="true" [appendTo]="'body'" styleClass="kanban-card-avatar--clicavel" imageClass="kanban-card-avatar" />
                            } @else {
                                <span class="kanban-card-avatar kanban-card-avatar--iniciais">{{ iniciaisDoNome(escolhido.nome) }}</span>
                            }
                            <span class="kanban-opcao-nome">{{ escolhido.nome }}</span>
                        </span>
                    }
                </ng-template>
                <ng-template pTemplate="item" let-opcao>
                    <span class="kanban-opcao-responsavel">
                        @if (fotoResponsavelPorId(opcao.idWebUsuario); as foto) {
                            <img class="kanban-card-avatar" [src]="foto" [alt]="opcao.nome" />
                        } @else {
                            <span class="kanban-card-avatar kanban-card-avatar--iniciais">{{ iniciaisDoNome(opcao.nome) }}</span>
                        }
                        <span class="kanban-opcao-nome">{{ opcao.nome }}</span>
                    </span>
                </ng-template>
            </p-select>
        }
        @if (destinoAvisaPendencia()) {
            <!--
                Só na coluna de pendências, e por flag do banco (`IN_AVISA_PENDENCIA`) — não pelo nome
                da coluna. Marcado, o movimento é gravado e em seguida a tela de detalhe abre o
                compositor de e-mail já preenchido: quem avisa o médico é o e-mail, e ele é revisado
                antes de sair. O texto é pergunta porque a resposta é do analista, não um padrão.
            -->
            <div class="kanban-aviso-medico mb-3">
                <p-checkbox inputId="kanban-avisar-medico" [binary]="true" [ngModel]="avisarMedico()" (ngModelChange)="avisarMedico.set($event)"></p-checkbox>
                <label for="kanban-avisar-medico">Avisar ao médico?</label>
            </div>
        }
        <label class="block mb-2 text-sm font-medium" for="kanban-anotacao">Anotação (opcional)</label>
        <textarea id="kanban-anotacao" pTextarea class="w-full" rows="4" maxlength="4000" [ngModel]="anotacao()" (ngModelChange)="anotacao.set($event)" placeholder="Registre o que motivou a mudança de etapa"></textarea>
    }

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="salvando()" (click)="cancelarMovimento()"></button>
        <button pButton type="button" label="Confirmar" [disabled]="salvando() || !podeConfirmar()" (click)="confirmarMovimento()"></button>
    </ng-template>
</p-dialog>

<!--
    Largura: a timeline alterna os eventos em duas colunas de flex IGUAL (`.p-timeline-event-opposite`
    e `.p-timeline-event-content`, ambas `flex: 1` no tema do PrimeNG), então o card sempre fica com
    METADE do diálogo — a outra metade é a linha de data/hora. Encolher a coluna da data não resolve:
    no `alternate` os lados trocam a cada linha, e o trilho dos marcadores ziguezaguearia.

    Daí 64rem (o app usa raiz de 12px, então ~768px): o card sai de ~235px para ~330px de largura, que
    é o que tira a anotação da compressão. `breakpoints` porque uma largura fixa desse tamanho estoura
    em tela estreita; abaixo de 480px de timeline o `pt` do `p-timeline` já colapsa para uma coluna só,
    com a data dentro do card.
-->
<p-dialog
    appDialogoPadrao="pi pi-history"
    descricao="Tudo o que já foi registrado no protocolo."
    header="Histórico do andamento"
    [visible]="historicoAberto() !== null"
    (visibleChange)="$event ? null : fecharHistorico()"
    [style]="{ width: '64rem' }"
    [breakpoints]="{ '960px': '90vw', '640px': '96vw' }"
>
    @if (historicoAberto(); as protocolo) {
        <!--
            Mesmo bloco de identificação do card do quadro: foto à esquerda e, ao lado dela, protocolo e
            nome empilhados. Estavam em duas linhas soltas — o badge sozinho numa e a foto com o nome na
            de baixo —, e o número do protocolo não se lia como sendo daquele solicitante.
            Sem rótulo "Protocolo": o badge é reconhecido pela forma, a mesma do card de onde o
            histórico foi aberto.
        -->
        <div class="kanban-dialogo-identificacao mb-3">
            <ng-container [ngTemplateOutlet]="avatarDoMedico" [ngTemplateOutletContext]="{ $implicit: protocolo }" />
            <span class="kanban-card-nomes">
                <span class="kanban-badge">{{ identificadorProtocolo(protocolo) }}</span>
                <strong class="kanban-card-solicitante">{{ protocolo.empresa }}</strong>
            </span>
        </div>
    }

    @if (carregandoHistorico()) {
        <p class="kanban-historico-vazio">Carregando…</p>
    } @else if (eventosHistorico(); as eventos) {
        @if (eventos.length) {
            <!--
                `@container` no próprio `p-timeline`: as consultas abaixo medem a LARGURA DELE, não a
                da janela — o mesmo diálogo aparece largo no desktop e estreito no celular, e é a
                largura disponível que decide se cabem as duas colunas do `alternate`. Abaixo de
                480px o lado oposto some e tudo alinha à esquerda, senão data e conteúdo brigariam
                por ~200px cada.
            -->
            <p-timeline
                [value]="eventos"
                align="alternate"
                class="w-full @container"
                [pt]="{
                    event: { class: '@max-[480px]:flex-row!' },
                    eventOpposite: { class: '@max-[480px]:hidden' },
                    eventContent: { class: '@max-[480px]:text-left!' },
                    eventConnector: { class: 'mb-4' }
                }"
            >
                <ng-template #opposite let-evento>
                    <div class="font-medium text-surface-700 dark:text-surface-200">{{ evento.data }}</div>
                    <div class="text-sm text-surface-500 dark:text-surface-400">{{ evento.hora }}</div>
                </ng-template>

                <!--
                    O modificador de cor sai do próprio `tipo` do evento (ver `.kanban-historico-marcador`
                    no SCSS): assim ícone e cor não podem divergir, e o presenter não precisa conhecer
                    nome de classe de CSS.
                    `aria-hidden` no ícone: a natureza do evento já está escrita no rótulo ao lado.
                -->
                <ng-template #marker let-evento>
                    <span [class]="'kanban-historico-marcador kanban-historico-marcador--' + evento.tipo">
                        <i [class]="evento.icone" aria-hidden="true"></i>
                    </span>
                </ng-template>

                <ng-template #content let-evento>
                    <div class="p-4 rounded-xl bg-surface-0 dark:bg-surface-800 border border-surface-200 dark:border-surface-700 shadow-sm mb-4 text-left">
                        <!-- Só quando o lado oposto está escondido: senão a data apareceria duas vezes na mesma linha. -->
                        <div class="hidden @max-[480px]:block mb-2 text-sm text-surface-500 dark:text-surface-400">{{ evento.data }} {{ evento.hora }}</div>
                        <!--
                            Cabeçalho do card: QUEM. Foto e nome lado a lado, como no card do quadro — o nome
                            já esteve numa linha solta abaixo do avatar, e os dois liam-se como informações
                            sem relação.
                        -->
                        <div class="flex items-center gap-3">
                            @if (fotoDoUsuarioDoHistorico(evento.usuario); as foto) {
                                <img [src]="foto" [alt]="evento.usuario" class="w-10 h-10 rounded-full object-cover shrink-0" />
                            } @else {
                                <p-avatar [label]="iniciaisDoNome(evento.usuario)" shape="circle" class="bg-primary/10! text-primary! font-semibold! shrink-0" [ariaLabel]="evento.usuario" />
                            }
                            <span class="font-semibold text-surface-900 dark:text-surface-0 min-w-0 break-words">{{ evento.usuario }}</span>
                        </div>

                        <!-- A linha separa QUEM (acima) do QUE ACONTECEU (abaixo): sem ela os dois viram um bloco só de texto. -->
                        <hr class="my-3 border-t border-surface-200 dark:border-surface-700" />

                        <!--
                            A movimentação sai nos MESMOS badges do diálogo de mover — origem, seta e destino,
                            cada um no tom da sua coluna. Em texto corrido, "BACKLOG → EXECUTANDO" não se ligava
                            visualmente às colunas do quadro atrás do diálogo.

                            `aria-label` com o título: dois `span` e uma seta não se leem em voz alta como uma
                            frase, e a seta é decorativa para quem ouve.
                        -->
                        @if (evento.statusDestino; as destino) {
                            <p class="kanban-dialogo-linha m-0" [attr.aria-label]="evento.titulo">
                                @if (evento.statusOrigem; as origem) {
                                    <span [class]="'kanban-badge-status ' + classeDeCorDoStatus(origem)">{{ origem }}</span>
                                    <span class="kanban-dialogo-seta" aria-hidden="true">&rarr;</span>
                                } @else {
                                    <span class="text-sm text-surface-500 dark:text-surface-400">Entrou em</span>
                                }
                                <span [class]="'kanban-badge-status kanban-badge-status--destino ' + classeDeCorDoStatus(destino)">{{ destino }}</span>
                            </p>
                        } @else {
                            <div class="font-bold text-surface-900 dark:text-surface-0">{{ evento.titulo }}</div>
                        }
                        <!--
                            Linha de e-mail não repete a mensagem aqui: o corpo inteiro esticava o card
                            por uma tela, e ele já está a um clique do botão abaixo, renderizado como o
                            médico o recebeu. Anotação comum continua sendo mostrada normalmente.
                        -->
                        @if (evento.anotacao && !evento.idAnotacaoComEmail) {
                            <p class="mt-2 mb-0 text-surface-600 dark:text-surface-300 text-sm leading-relaxed whitespace-pre-wrap">{{ evento.anotacao }}</p>
                        }
                        @if (evento.idAnotacaoComEmail; as idAnotacao) {
                            <!--
                                O texto acima é a versão legível do e-mail; aqui se vê a mensagem como o
                                médico a recebeu, com a formatação do template. Só aparece na linha que
                                TEM e-mail guardado — botão que abre frame vazio é pior que botão nenhum.
                            -->
                            <p-button class="mt-3 block" label="Ver e-mail enviado" icon="pi pi-envelope" severity="secondary" size="small" [text]="true" [loading]="carregandoEmail()" (onClick)="abrirEmail(idAnotacao)" />
                        }
                        @if (evento.encaminhadoPara) {
                            <div class="kanban-historico-encaminhado mt-3 p-2 rounded-lg bg-surface-100 dark:bg-surface-700 text-sm text-surface-600 dark:text-surface-300 flex items-center gap-2">
                                <i class="pi pi-send shrink-0" aria-hidden="true"></i>
                                Encaminhado para {{ evento.encaminhadoPara }}
                            </div>
                        }
                    </div>
                </ng-template>
            </p-timeline>
        } @else {
            <p class="kanban-historico-vazio">Este protocolo ainda não tem movimentação registrada.</p>
        }

        @if (!protocoloDoHistoricoRastreado()) {
            <!-- Ação desabilitada sem explicação vira chamado de suporte. -->
            <p class="kanban-historico-aviso" role="note">Este protocolo ainda não foi movido no quadro. Mova-o uma vez e o andamento poderá ser registrado.</p>
        }
    }

    <!--
        A ação fica no pé, junto de Fechar: as duas são o que se faz DEPOIS de ler a linha do tempo.
        Escrever abre um diálogo próprio, em vez de um campo aqui — o histórico já é alto, e um campo
        no fim ficaria fora da vista de quem acabou de ler a primeira linha, no topo.
    -->
    <ng-template pTemplate="footer">
        <!-- Perfil nacional acompanha o histórico e não escreve nele: o servidor recusaria o andamento. -->
        @if (!somenteLeitura()) {
            <button
                pButton
                type="button"
                label="Adicionar andamento"
                icon="pi pi-plus"
                class="p-button-text"
                [disabled]="!protocoloDoHistoricoRastreado()"
                [title]="protocoloDoHistoricoRastreado() ? '' : 'Disponível depois que o protocolo entrar no quadro'"
                (click)="abrirNovoAndamento()"
            ></button>
        }
        <button pButton type="button" label="Fechar" class="p-button-text" (click)="fecharHistorico()"></button>
    </ng-template>
</p-dialog>

<!--
    Sobreposto ao histórico, e não no lugar dele: quem escreve o andamento está olhando a linha do
    tempo para decidir o que registrar, e fechá-la tiraria da vista justamente essa referência.
-->
<p-dialog
    appDialogoPadrao="pi pi-plus"
    descricao="Novo registro na linha do tempo do protocolo."
    header="Adicionar andamento"
    [visible]="escrevendoAndamento()"
    (visibleChange)="$event ? null : fecharNovoAndamento()"
    [style]="{ width: '34rem' }"
    [breakpoints]="{ '640px': '94vw' }"
    [closable]="!salvandoAndamento()"
    [closeOnEscape]="!salvandoAndamento()"
>
    <label class="block mb-2 text-sm font-medium" for="kanban-novo-andamento">O que aconteceu neste protocolo</label>
    <textarea
        id="kanban-novo-andamento"
        pTextarea
        class="w-full mb-3"
        rows="5"
        maxlength="4000"
        [disabled]="salvandoAndamento()"
        [ngModel]="novoAndamento()"
        (ngModelChange)="novoAndamento.set($event)"
        placeholder="Registre o andamento para quem abrir o histórico depois"
    ></textarea>

    <!--
        Opcional, e por isso abaixo do texto: encaminhar acompanha o andamento, não o substitui. Em
        branco, o protocolo continua com o dono atual. Escolhido, o andamento vira o MOTIVO do
        encaminhamento — e é assim que ele aparece na timeline, como "Encaminhamento".
    -->
    <label class="block mb-2 text-sm font-medium" for="kanban-encaminhar">Encaminhar para (opcional)</label>
    <p-select
        inputId="kanban-encaminhar"
        styleClass="w-full"
        [options]="responsaveis()"
        optionLabel="nome"
        optionValue="idWebUsuario"
        [showClear]="true"
        [filter]="true"
        filterBy="nome"
        [disabled]="salvandoAndamento()"
        placeholder="Manter o responsável atual"
        appendTo="body"
        [ngModel]="encaminharPara()"
        (ngModelChange)="encaminharPara.set($event)"
    >
        <ng-template pTemplate="selectedItem" let-escolhido>
            @if (escolhido) {
                <span class="kanban-opcao-responsavel">
                    @if (fotoResponsavelPorId(escolhido.idWebUsuario); as foto) {
                        <img class="kanban-card-avatar" [src]="foto" [alt]="escolhido.nome" />
                    } @else {
                        <span class="kanban-card-avatar kanban-card-avatar--iniciais">{{ iniciaisDoNome(escolhido.nome) }}</span>
                    }
                    <span class="kanban-opcao-nome">{{ escolhido.nome }}</span>
                </span>
            }
        </ng-template>
        <ng-template pTemplate="item" let-opcao>
            <span class="kanban-opcao-responsavel">
                @if (fotoResponsavelPorId(opcao.idWebUsuario); as foto) {
                    <img class="kanban-card-avatar" [src]="foto" [alt]="opcao.nome" />
                } @else {
                    <span class="kanban-card-avatar kanban-card-avatar--iniciais">{{ iniciaisDoNome(opcao.nome) }}</span>
                }
                <span class="kanban-opcao-nome">{{ opcao.nome }}</span>
            </span>
        </ng-template>
    </p-select>

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="salvandoAndamento()" (click)="fecharNovoAndamento()"></button>
        <button pButton type="button" label="Salvar" icon="pi pi-check" [disabled]="!podeInserirAndamento()" [loading]="salvandoAndamento()" (click)="inserirAndamento()"></button>
    </ng-template>
</p-dialog>

<!--
    Sobreposto ao diálogo do histórico, e não no lugar dele: quem clicou em "Ver e-mail" está lendo a
    linha do tempo e volta para ela — fechar o histórico para mostrar o e-mail perderia o ponto da
    leitura. O e-mail é largo por natureza (template de coluna fixa), daí a largura maior.
-->
<p-dialog
    appDialogoPadrao="pi pi-envelope"
    descricao="Mensagem disparada pelo protocolo."
    header="E-mail enviado ao médico"
    [visible]="emailAberto() !== null"
    (visibleChange)="$event ? null : fecharEmail()"
    [style]="{ width: '70rem' }"
    [breakpoints]="{ '1200px': '92vw', '640px': '98vw' }"
>
    @if (emailAberto(); as html) {
        <app-visualizador-email [html]="html" titulo="E-mail enviado ao médico" />
    }

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Fechar" class="p-button-text" (click)="fecharEmail()"></button>
    </ng-template>
</p-dialog>

<!--
    Avatar do médico, usado no card e nos dois diálogos que trazem nome e protocolo. Sempre colado à
    esquerda do nome.

    Na maioria dos serviços ele é decorativo: `aria-hidden` evita que o leitor de tela anuncie a foto
    e em seguida o nome que ela ilustra — e no card o alt entraria no nome acessível do botão ("Foto
    de Fulano 143/2026 Fulano"). Ali o rosto é exatamente de quem está escrito ao lado.

    No pré-prestador é o oposto: o nome ao lado é o da EMPRESA e o rosto é do diretor técnico, outra
    pessoa. Sem rótulo, ninguém sabe de quem é aquele rosto — nem o leitor de tela, nem quem enxerga
    e pode lê-lo como sendo da empresa. `rotuloAvatarMedico` decide, por serviço: vazio mantém o
    avatar decorativo; preenchido, ele vira o `alt`/`title` da imagem e tira o `aria-hidden`.
-->
<ng-template #avatarDoMedico let-item>
    <span class="kanban-card-avatares" [attr.aria-hidden]="rotuloAvatarMedico(item) ? null : true" [title]="rotuloAvatarMedico(item) || null">
        @if (fotoMedico(item); as foto) {
            <!--
                `p-image` com `preview`: o clique amplia o retrato, o mesmo da coluna de perfil do
                `app-custom-table`. `appendTo="body"` porque o overlay nasceria dentro do card, que
                tem recorte e ainda rola junto da coluna. O `stopPropagation` impede que o clique
                escape para o card, que é arrastável e cujo nome ao lado abre o protocolo.

                O `title` vive no <span> de cima porque o `p-image` não repassa esse atributo — e sem
                ele quem passa o mouse não sabe de quem é o rosto (na pessoa jurídica ele é do diretor
                técnico, e o nome ao lado é o da empresa).
            -->
            <p-image [src]="foto" [alt]="rotuloAvatarMedico(item) || ''" [preview]="true" [appendTo]="'body'" styleClass="kanban-card-avatar--clicavel" imageClass="kanban-card-avatar" (click)="$event.stopPropagation()" />
        } @else if (iniciaisMedico(item); as iniciais) {
            <!--
                Sem foto cadastrada e o CASO COMUM, nao o raro: no pre-prestador o estado mais
                provavel e exatamente este, e quem passa o mouse sobre duas iniciais ao lado do nome
                da empresa precisa do mesmo title da foto para saber de quem elas sao.
            -->
            <span class="kanban-card-avatar kanban-card-avatar--iniciais" [attr.aria-label]="rotuloAvatarMedico(item) || null" [title]="rotuloAvatarMedico(item) || null">{{ iniciais }}</span>
        }
    </span>
</ng-template>

<!--
    Um diálogo só, e não um por coluna: o conteúdo vem de `camposDoFiltro()`, que já sabe o que a
    coluna aberta oferece. O painel edita um RASCUNHO — o quadro fica atrás dele, e aplicar a cada
    tecla mudaria uma tela que ninguém está vendo.
-->
<p-dialog
    appDialogoPadrao="pi pi-briefcase"
    descricao="Recorte os cartões desta coluna."
    [header]="'Filtrar ' + (colunaEmFiltro()?.nome ?? '')"
    [visible]="colunaEmFiltro() !== null"
    (visibleChange)="$event ? null : fecharFiltro()"
    [style]="{ width: '30rem' }"
    [breakpoints]="{ '640px': '94vw' }"
>
    <div class="kanban-filtro-campos">
        @for (campo of camposDoFiltro(); track campo) {
            @switch (campo) {
                @case (ECampoFiltro.SITUACAO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-situacao">Situação no portal</label>
                        <p-select
                            inputId="filtro-situacao"
                            styleClass="w-full"
                            [options]="opcoesSituacaoFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Qualquer uma"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().situacao ?? null"
                            (ngModelChange)="definirNoRascunho('situacao', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.MODALIDADE) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-modalidade">Modalidade</label>
                        <p-select
                            inputId="filtro-modalidade"
                            styleClass="w-full"
                            [options]="opcoesModalidadeFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Qualquer uma"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().modalidade ?? null"
                            (ngModelChange)="definirNoRascunho('modalidade', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.PAGAMENTO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-pagamento">Pagamento</label>
                        <p-select
                            inputId="filtro-pagamento"
                            styleClass="w-full"
                            [options]="opcoesPagamentoFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Tanto faz"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().pagamento ?? null"
                            (ngModelChange)="definirNoRascunho('pagamento', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.INDICACAO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-indicacao">Indicação do diretor</label>
                        <p-select
                            inputId="filtro-indicacao"
                            styleClass="w-full"
                            [options]="opcoesIndicacaoFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Qualquer uma"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().indicacao ?? null"
                            (ngModelChange)="definirNoRascunho('indicacao', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.RESPONSAVEL) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-responsavel">Responsável</label>
                        <p-select
                            inputId="filtro-responsavel"
                            styleClass="w-full"
                            [options]="responsaveis()"
                            optionLabel="nome"
                            optionValue="idWebUsuario"
                            [showClear]="true"
                            [filter]="true"
                            filterBy="nome"
                            placeholder="Qualquer um"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().responsavel ?? null"
                            (ngModelChange)="definirNoRascunho('responsavel', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.CRITICIDADE) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-criticidade">Criticidade</label>
                        <p-select
                            inputId="filtro-criticidade"
                            styleClass="w-full"
                            [options]="criticidades()"
                            optionLabel="nome"
                            optionValue="id"
                            [showClear]="true"
                            placeholder="Qualquer uma"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().criticidade ?? null"
                            (ngModelChange)="definirNoRascunho('criticidade', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.PARADO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-parado">Parado há mais de (dias)</label>
                        <p-inputnumber
                            inputId="filtro-parado"
                            styleClass="w-full"
                            [min]="0"
                            [showButtons]="true"
                            placeholder="Qualquer tempo"
                            [ngModel]="rascunhoFiltro().paradoDias ?? null"
                            (ngModelChange)="definirNoRascunho('paradoDias', $event)"
                        ></p-inputnumber>
                    </div>
                }
                @case (ECampoFiltro.ESPERA) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-espera">Aguardando há mais de (dias)</label>
                        <p-inputnumber
                            inputId="filtro-espera"
                            styleClass="w-full"
                            [min]="0"
                            [showButtons]="true"
                            placeholder="Qualquer tempo"
                            [ngModel]="rascunhoFiltro().esperaDias ?? null"
                            (ngModelChange)="definirNoRascunho('esperaDias', $event)"
                        ></p-inputnumber>
                    </div>
                }
                @case (ECampoFiltro.EX_OFFICIO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-ex-officio">Inscrição ex officio</label>
                        <p-select
                            inputId="filtro-ex-officio"
                            styleClass="w-full"
                            [options]="opcoesExOfficioFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Tanto faz"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().exOfficio ?? null"
                            (ngModelChange)="definirNoRascunho('exOfficio', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.ANOTACAO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-anotacao">Anotação</label>
                        <p-select
                            inputId="filtro-anotacao"
                            styleClass="w-full"
                            [options]="opcoesAnotacaoFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Tanto faz"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().anotacao ?? null"
                            (ngModelChange)="definirNoRascunho('anotacao', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.AVISO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-aviso">Aviso ao médico</label>
                        <p-select
                            inputId="filtro-aviso"
                            styleClass="w-full"
                            [options]="opcoesAvisoFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Tanto faz"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().aviso ?? null"
                            (ngModelChange)="definirNoRascunho('aviso', $event)"
                        ></p-select>
                    </div>
                    <div class="kanban-filtro-campo">
                        <label for="filtro-aviso-dias">Avisado há mais de (dias)</label>
                        <p-inputnumber
                            inputId="filtro-aviso-dias"
                            styleClass="w-full"
                            [min]="0"
                            [showButtons]="true"
                            placeholder="Qualquer tempo"
                            [ngModel]="rascunhoFiltro().avisoDias ?? null"
                            (ngModelChange)="definirNoRascunho('avisoDias', $event)"
                        ></p-inputnumber>
                    </div>
                }
                @case (ECampoFiltro.DESFECHO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-desfecho">Desfecho</label>
                        <p-select
                            inputId="filtro-desfecho"
                            styleClass="w-full"
                            [options]="opcoesDesfechoFiltro"
                            optionLabel="rotulo"
                            optionValue="valor"
                            [showClear]="true"
                            placeholder="Qualquer um"
                            appendTo="body"
                            [ngModel]="rascunhoFiltro().desfecho ?? null"
                            (ngModelChange)="definirNoRascunho('desfecho', $event)"
                        ></p-select>
                    </div>
                }
                @case (ECampoFiltro.CONCLUSAO) {
                    <div class="kanban-filtro-campo">
                        <label for="filtro-concluido-de">Concluído de</label>
                        <input id="filtro-concluido-de" type="date" class="w-full" [ngModel]="rascunhoFiltro().concluidoDe ?? ''" (ngModelChange)="definirNoRascunho('concluidoDe', $event)" />
                    </div>
                    <div class="kanban-filtro-campo">
                        <label for="filtro-concluido-ate">Concluído até</label>
                        <input id="filtro-concluido-ate" type="date" class="w-full" [ngModel]="rascunhoFiltro().concluidoAte ?? ''" (ngModelChange)="definirNoRascunho('concluidoAte', $event)" />
                    </div>
                }
            }
        }
    </div>

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Limpar" class="p-button-text" (click)="limparFiltro()"></button>
        <button pButton type="button" label="Aplicar" (click)="aplicarFiltro()"></button>
    </ng-template>
</p-dialog>
